import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from '../api/axiosInstance.js';

function LoginPage({ setIsAuthenticated }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post('/auth/login', { username, password });
      const { access_token } = response.data;
      if (access_token) {
        localStorage.setItem('authToken', access_token);
        setIsAuthenticated(true);
        navigate('/');
      } else alert('Невдалий вхід: Не отримано ключ.');
    } catch (err) {
      alert('Недійсні облікові дані або помилка сервера');
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen">
      <h1 className="text-2xl mb-4">Логін</h1>
      <form onSubmit={handleSubmit} className="flex flex-col space-y-4">
        <input type="text" placeholder="Користувач" value={username} onChange={(e) => setUsername(e.target.value)} className="border p-2" />
        <input type="password" placeholder="Пароль" value={password} onChange={(e) => setPassword(e.target.value)} className="border p-2" />
        <button type="submit" className="bg-blue-500 text-white p-2 rounded">Логін</button>
      </form>
    </div>
  );
}

export default LoginPage;
